// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadDirectMerchants } from './reducer/directMerchants';
import DirectMerchantsIndexTable from './DirectMerchantsIndexTable';
import { MerchantsDiv } from '../../MerchantsStyles';
import DirectMerchantsFilters from './DirectMerchantsFilters';
import {
  changePage,
  setSearchFilter,
  setStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  downloadCsv,
  setPerPage
} from './reducer/filters';
import { showTooltip, changeSortOrder, resetState } from './reducer/views';
import { type Currencies, type Merchant } from '../../../../utilities/types';
import TableStatistics from './TableStatistics';
import { withRouter } from 'react-router-dom';

type Props = {
  loading: boolean,
  loadDirectMerchants: () => void,
  search: string,
  setSearchFilter: (value: string) => void,
  statusFilter: ?string,
  setStatusFilter: (value: string) => void,
  downloadCsv: () => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  startDate?: string,
  endDate?: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  setCalendarSaga: () => void,
  currencies: Currencies,
  showTooltip: (tooltip: string) => void,
  activeTooltip: ?string,
  orderBy: ?string,
  orderDirection: ?string,
  changeSortOrder: (orderBy: string) => void,
  paginatorTotal: number,
  currentPage: number,
  previouslyVisited: number[],
  changePage: (value: number) => void,
  perPage: string,
  directMerchants: Array<Merchant>,
  viewportDevice: string,
  setPerPage: (perPage: number) => void,
  resetState: () => void,
  setActiveSubsection: (subsection: number) => void,
  failedLoad: boolean
  // location: Location
};

class DirectMerchantsIndex extends Component<Props> {
  componentDidMount() {
    this.props.loadDirectMerchants();
  }

  componentWillUnmount() {
    // Requirement is to reset filters between tabs on the merchants page as well.
    // if (this.props.location.pathname.includes('/merchants')) return;
    this.props.resetState();
  }
  render() {
    const availableMerchantStatusOptions = [
      { text: 'New', value: 'new' },
      { text: 'Partially Filled', value: 'partially_filled' },
      { text: 'Pending', value: 'pending' },
      { text: 'Denied', value: 'denied' },
      { text: 'Approved', value: 'approved' }
    ];
    return (
      <>
        <DirectMerchantsFilters
          // Search Filter Props
          searchValue={this.props.search}
          setSearchFilter={this.props.setSearchFilter}
          // Status Filter Props
          status={this.props.statusFilter}
          setStatusFilter={this.props.setStatusFilter}
          availableStatuses={availableMerchantStatusOptions}
          // Download CSV
          downloadCsv={this.props.downloadCsv}
          // Date Filter
          toggleCalendarFilter={this.props.toggleCalendarFilter}
          calendarFilterState={this.props.calendarFilterState}
          calendarStart={this.props.startDate}
          calendarEnd={this.props.endDate}
          clearCalendarFilter={this.props.clearCalendarFilter}
          setCalendarStartFilter={this.props.setCalendarStartFilter}
          setCalendarEndFilter={this.props.setCalendarEndFilter}
          windowSize={this.props.viewportDevice}
          setCalendarSaga={this.props.setCalendarSaga}
          disabled={false}
        />
        <MerchantsDiv>
          <TableStatistics />
          <DirectMerchantsIndexTable
            // Sortable Table Header Props
            loading={this.props.loading}
            failedLoad={this.props.failedLoad}
            orderBy={this.props.orderBy}
            orderDirection={this.props.orderDirection}
            changeSortOrder={this.props.changeSortOrder}
            directMerchants={this.props.directMerchants}
            paginatorTotal={this.props.paginatorTotal}
            currentPage={this.props.currentPage}
            previouslyVisited={this.props.previouslyVisited}
            changePage={this.props.changePage}
            currentPerPage={this.props.perPage || ''}
            // $FlowFixMe
            setPerPage={this.props.setPerPage}
            perPageOptions={[10, 25, 50]}
            showTooltip={this.props.showTooltip}
            activeTooltip={this.props.activeTooltip}
            currencies={this.props.currencies}
            resetState={this.props.resetState}
            setActiveSubsection={this.props.setActiveSubsection}
          />
        </MerchantsDiv>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.merchants.directMerchants.index.directMerchants.loading,
  failedLoad: state.merchants.directMerchants.index.directMerchants.failedLoad,
  directMerchants: state.merchants.directMerchants.index.directMerchants.users,
  hasFailedMerchantRegistrations:
    state.merchants.directMerchants.index.directMerchants
      .has_failed_merchant_registrations,
  currentPage: state.merchants.directMerchants.index.filters.currentPage,
  previouslyVisited:
    state.merchants.directMerchants.index.filters.previouslyVisited,
  paginatorTotal: state.merchants.directMerchants.index.filters.paginatorTotal,
  currencies: state.global.currencies,
  search: state.merchants.directMerchants.index.filters.search,
  statusFilter: state.merchants.directMerchants.index.filters.status,
  calendarFilterState:
    state.merchants.directMerchants.index.filters.calendarFilterState,
  startDate: state.merchants.directMerchants.index.filters.startDate,
  endDate: state.merchants.directMerchants.index.filters.endDate,
  perPage: state.merchants.directMerchants.index.filters.perPage,
  activeTooltip: state.merchants.directMerchants.index.views.activeTooltip,
  orderBy: state.merchants.directMerchants.index.views.orderBy,
  orderDirection: state.merchants.directMerchants.index.views.orderDirection,
  viewportDevice: state.global.viewportDevice
});

const mapDispatchToProps = {
  loadDirectMerchants,
  changePage,
  setSearchFilter,
  setStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  downloadCsv,
  setPerPage,
  showTooltip,
  changeSortOrder,
  resetState
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DirectMerchantsIndex)
);
